module.exports = __webpack_public_path__ + "img/11.5a12e553.png";